import { z } from 'zod';
import { findSegmentFieldMeta, SEGMENT_OPS } from '../audience/segmentFieldCatalog.js';
export const segmentExclusionsSchema = z.object({
    respect_suppressions: z.boolean().default(true),
    exclude_do_not_contact: z.boolean().default(true),
});
export const segmentRuleSchema = z.object({
    id: z.string().min(1).max(40),
    entity: z.enum(['lead', 'account']),
    field: z.string().min(1).max(80),
    op: z.enum(SEGMENT_OPS),
    value: z.union([z.string(), z.number(), z.boolean(), z.array(z.string())]).optional(),
    availability: z.enum(['live', 'partial', 'planned']).optional(),
});
export const segmentDefinitionSchema = z
    .object({
    version: z.literal(1),
    logic: z.enum(['and']).default('and'),
    rules: z.array(segmentRuleSchema).max(32),
    exclusions: segmentExclusionsSchema.default({
        respect_suppressions: true,
        exclude_do_not_contact: true,
    }),
})
    .superRefine((def, ctx) => {
    for (let i = 0; i < def.rules.length; i += 1) {
        const rule = def.rules[i];
        if (rule.availability === 'planned') {
            ctx.addIssue({
                code: 'custom',
                message: `Regel ${rule.id}: filter niet beschikbaar (planned)`,
                path: ['rules', i],
            });
            continue;
        }
        const meta = findSegmentFieldMeta(rule.entity, rule.field);
        if (!meta) {
            ctx.addIssue({
                code: 'custom',
                message: `Regel ${rule.id}: onbekend veld ${rule.entity}.${rule.field}`,
                path: ['rules', i],
            });
            continue;
        }
        if (!meta.ops.includes(rule.op)) {
            ctx.addIssue({
                code: 'custom',
                message: `Regel ${rule.id}: operator ${rule.op} niet toegestaan`,
                path: ['rules', i],
            });
        }
        if (rule.op === 'exists' || rule.op === 'not_exists')
            continue;
        if (rule.value === undefined || rule.value === '') {
            ctx.addIssue({
                code: 'custom',
                message: `Regel ${rule.id}: waarde verplicht`,
                path: ['rules', i, 'value'],
            });
        }
    }
});
export const audiencePreviewSchema = z.object({
    project_id: z.string().uuid(),
    definition: segmentDefinitionSchema,
});
//# sourceMappingURL=segmentDefinition.js.map